import sendEvent from './sendEvent';
import {
  DATA,
  DISPLAY_TEXT,
  ERRORCODE,
  ERRORCODE_DEFAULT,
  ERRORCODE_UNAUTHORIZED,
  SENDER
} from './constants';
import pick from '../../utils/pick';

const reportError = (sender, errorSpec, httpMethod) => {
  if (!sender) {
    return;
  }
  if (!errorSpec || (!errorSpec.response && !errorSpec.error)) {
    return;
  }
  let displayText = null;
  let data = null;
  let errorCode = ERRORCODE_DEFAULT;

  if (errorSpec.response) {
    const resp = errorSpec.response;
    if (resp.status === 401) {
      errorCode = ERRORCODE_UNAUTHORIZED;
    }
    data = {
      method: httpMethod || 'unknown',
      ...pick(['status', 'statusText', 'url'])(resp)
    };
  } else if (errorSpec.error) {
    data = {
      error: '' + errorSpec.error
    };
  }

  const payload = {
    [ERRORCODE]: errorCode,
    [SENDER]: sender,
    [DISPLAY_TEXT]: displayText,
    [DATA]: data
  };
  sendEvent(payload);
};

export default reportError;
